import React from 'react'
import PropTypes from 'prop-types'
import { BeatLoader } from 'react-spinners'

import styles from './LoadingComponent.module.css'

const LoadingComponent = ({ message }) => (
  <div className={styles.container}>
    <BeatLoader />
  </div>
)

LoadingComponent.propTypes = {
  message: PropTypes.string,
}

export default LoadingComponent
